"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clearIcon = _interopRequireDefault(require("../utils/clear-icon"));

var _modal = require("./modal.styles");

var _jsxRuntime = require("react/jsx-runtime");

const ModalCloseButton = ({
  onClick,
  ...props
}) => {
  const clickHandler = event => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    onClick && onClick(event);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_modal.StyledModalCloseButton, {
    type: "button",
    onClick: clickHandler,
    className: "nextui-modal-close-icon",
    "aria-label": "Close",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_clearIcon.default, {
      plain: true,
      size: 18,
      className: "nextui-modal-close-icon-svg",
      fill: "currentColor",
      "aria-hidden": true
    })
  });
};

ModalCloseButton.toString = () => '.nextui-modal-close-icon';

const MemoModalCloseButton = /*#__PURE__*/_react.default.memo(ModalCloseButton);

var _default = MemoModalCloseButton;
exports.default = _default;
module.exports = exports.default;